export default function Welcome() {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h1 className="text-4xl font-bold text-gray-900 mb-4">Welcome to SBCLite</h1>
        <p className="text-xl text-gray-600 mb-8">
          Your Cloud-Native Session Border Controller is ready
        </p>
      </div>

      <div className="bg-white shadow rounded-lg">
        <div className="px-4 py-5 sm:p-6">
          <h3 className="text-lg leading-6 font-medium text-gray-900 mb-4">Getting Started</h3>
          <div className="text-sm text-gray-500">
            <p className="mb-4">
              Your SBCLite instance is successfully running with authentication enabled.
            </p>
            <div className="rounded-md bg-blue-50 p-4">
              <div className="text-sm text-blue-700">
                <p className="font-medium mb-2">Ready for Development:</p>
                <ul className="list-disc list-inside space-y-1">
                  <li>Authentication system is fully functional</li>
                  <li>Navigation shell is prepared for new features</li>
                  <li>Backend API integration is configured</li>
                  <li>Start building your SIP infrastructure management interface</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
